import { SessionManager } from "@/services/session.manager";
import { useRouter } from "vue-router";

export function useLogout() {
    const router = useRouter()

    function logout() {
        SessionManager.clearAuth()
        router.push({
            path: '/login'
        })
    }

    return logout
}